import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=f46d0912&scoped=true"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=f46d0912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46d0912",
  null
  
)

export default component.exports